import type { DeepPartial } from '@luna/utils-ts';

import type { Trading } from '../../types';

export const tradingConfigRO: DeepPartial<Trading> = {
    applyValidFromForSell: true,
    buyOrderExpectedFeeTypes: ['MAX_FEE', 'ENTRY_FEE'],
    sellOrderExpectedFeeTypes: ['MAX_FEE', 'EXIT_FEE'],
    shouldLoadTradingDocuments: true,
    showAdvisorCode: true,
    showTargetPortfolio: true,
    tradingValidationStrategies: {
        accountNotAllowedToTradeFlag: true,
    },
};
